import styled from 'styled-components';
import { crTheme, Link } from '@comicrelief/component-library';

const privacyNotice = 'Find out how we use your information on our ';
const privacyHref = 'https://www.comicrelief.com/privacy-notice/';

const Wrapper = styled.div`
  margin-top: 2.5rem;
  text-align: center;
  font-size: 0.75rem;
  color: ${crTheme.color('grey_dark')};
`;

const PrivacyLink = styled(Link)`
  color: ${crTheme.color('blue_donate')};
`;

export default function PrivacyNotice() {
  return (
    <Wrapper>
      {privacyNotice}
      {' '}
      <PrivacyLink
        href={privacyHref}
        target="blank"
        data-test="privacy-notice"
      >
        privacy notice
      </PrivacyLink>
    </Wrapper>
  );
}
